import React from 'react';
import { Navigate } from 'react-router-dom';

/** Analytics lives on the Study hub; keep route for bookmarks and nav compatibility. */
const UserAnalytics = () => <Navigate to="/dashboard#study-analytics" replace />;

export default UserAnalytics;
